<ng-container *ngIf="document$ | async as doc">
  <button class="dismiss-button" mat-icon-button color="primary" (click)="dismiss()">
    <mat-icon><img src="assets/images/icon-close.svg" /></mat-icon>
  </button>
  <h1>{{doc.propertiesObj.DocumentTitle}}</h1>
  <div class="content">
    <ng-template #loading>
      <mat-spinner></mat-spinner>
    </ng-template>

    <img *ngIf="!thumbnailWait; else loading" #thumbnailImg class="preview" (error)="thumbnailError()"
      [src]=" filenetURL + '/getDocumentThumbnail?objectStoreName='+data.objectStore+'&documentID='+doc?.id ">
    <div class="general">
      <div><b>Document Class:</b>
        {{ doc.propertiesObj.ClassDescription | asyncChoiceList:data.objectStore:'ACLDocumentClasses' | async}}
      </div>
      <div><b>Contract Indentifier:</b> {{ doc.propertiesObj.ContractIdentifier}}</div>
      <div><b>Contract Name:</b> {{ doc.propertiesObj.DocumentTitle}}</div>
      <div><b>Linked Documents:</b><br>
        <ul>
          <ng-container *ngFor="let link of linkedDocuments$ | async; let i = index; let last = last">
            <br *ngIf="last">
            <li *ngIf="i < 3 || last">
              <a (click)="dismiss()" class="linkedDocument" *ngIf="i < 3 && !link?.noAccess" target="_blank"
                href="{{filenetURL}}/getDocumentContent?objectStoreName={{data.objectStore}}&documentID={{link?.id}}">{{link.propertiesObj.DocumentTitle}}
                ({{link?.propertiesObj.ContractIdentifier}})</a>
              <span class="linkedDocument" *ngIf="i < 3 && link?.noAccess">{{link.propertiesObj.DocumentTitle}}
                ({{link?.propertiesObj.ContractIdentifier}})</span>
              <div *ngIf="i >=3 && last">
                <a (click)="dismiss()" class="linkedDocument" target="_blank"
                  [routerLink]="['/',data.objectStore,'DocumentView',doc.id]"
                  [queryParams]="{currentTab:'LinkedDocuments'}">View
                  Linked Documents</a>

              </div>
            </li>
          </ng-container>

        </ul>

      </div>
      <div><b>Contract Status:</b>
        {{ doc.propertiesObj.ContractStatus | asyncChoiceList:data.objectStore:'ContractStatuses' | async }}
      </div>
      <div><b>Type of Agreement:</b>
        {{ doc.propertiesObj.ContractAgreementType | asyncChoiceList:data.objectStore:'ContractAgreementTypes' | async }}
      </div>
      <div><b>Contract Start Date:</b> {{ doc.propertiesObj.ContractStartDate | aspenDate   }} </div>
      <div><b>Contract End Date:</b> {{ doc.propertiesObj.ContractEndDate | aspenDate   }} </div>
      <div><b>Signature Date:</b> {{ doc.propertiesObj.ContractDateOfLastSignature | aspenDate   }}</div>
      <div><b>Review Deadline Date:</b> {{ doc.propertiesObj.ContractReviewDeadlineDate | aspenDate   }}
        <div><b>Number of Comments: </b><a (click)="dismiss()" class="linkedDocument"
            [routerLink]="['/',data.objectStore,'DocumentView',doc.id]" target="_blank"
            [queryParams]="{currentTab:'Comments'}">{{doc?.annotations?.length}}</a>
        </div>
      </div>
      <hr>
      <div><b>Added By:</b> {{doc.propertiesObj.Creator   }} </div>
      <div><b>Added On:</b> {{doc.propertiesObj.DateCreated | aspenDate }} </div>
      <div><b>Modified By:</b> {{doc.propertiesObj.LastModifier   }}</div>
      <div><b>Modified On:</b> {{doc.propertiesObj.DateLastModified | aspenDate }}</div>
      <hr>
      <a class="copyLink" *ngIf="data.objectStore"
        (click)="copyMessage('/' + data.objectStore + '/DocumentView/' + doc.id)">Copy
        link to document</a>
    </div>
  </div>

</ng-container>
